import axios from '@/plugins/axios'
import { Module } from 'vuex'
import { sortResults, sortCollection, sortCollection } from '@/utils/collections'

const tagModule: Module<any, any> = {
    actions: {
        async initTagIndex() {
            if (this.tagIndexLoading) {
        		await this.initTagPromise
        		return
        	}
            this.tagIndexLoading = true
            this.initTagPromise = this.dispatch('initIndex', {
                id: 'tag',
                idField: 'slug',
                indexedFields: [
                    'name',
                ],
                source: '/api/tags',
                refresh: true,
            })
            await this.initTagPromise
            this.tagIndexLoading = false
            this.initTagPromise = null
        },

        async getTags(_, params) {
            const indexExists = await this.dispatch('indexExists', 'tag')
            if (!indexExists || params?.refresh) {
                await this.dispatch('initTagIndex')
            }

            const slugsFilter = (items) => {
                const filter = params.slugs
                return filter
                    ? items?.filter((e) => filter.includes(e.slug))
                    : items
            }

            const startDateFilter = (items) => {
                const filter = params.start
                return filter
                    ? items?.filter((e) => !e.createdAt || e.createdAt <= filter)
                    : items
            }

            const endDateFilter = (items) => {
                const filter = params.end
                return filter
                    ? items?.filter((e) => !e.createdAt || e.createdAt >= filter)
                    : items
            }

            const sortName = (items) => {
                return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortPosts = (items) => {
                return sortCollection(items, 'stats.postsDelivered', params?.sortOrder?.toLowerCase() === 'asc')
            }
            
            const sortEngagements = (items) => {
                return items?.sort((a, b) =>
                a?.stats.likes + a?.stats.comments + a?.stats.reshares < b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? -1 : 1
                    : a?.stats.likes + a?.stats.comments + a?.stats.reshares > b?.stats.likes + b?.stats.comments + b?.stats.reshares
                    ? params?.sortOrder?.toLowerCase() === 'asc' ? 1 : -1
                    : 0,
                )
            }
            
            const sortClicks = (items) => {
                return sortCollection(items, 'stats.clicks', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const sortMediaPoints = (items) => {
                return sortResults(items, 'mediaPoints', params?.sortOrder)
            }

            const getSortOrder = () => {
                if (params?.sortBy === 'posts') {
                    return sortPosts
                } else if (params?.sortBy === 'engagements') {
                    return sortEngagements
                } else if (params?.sortBy === 'clicks') {
                    return sortClicks
                } else if (params?.sortBy === 'media_points') {
                    return sortMediaPoints
                } else {
                    return sortName
                }
            }

            let records = null
            records = await this.dispatch('getRecords', {
                index: 'tag',
                term: params?.search,
                fields: ['name'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                filters: [slugsFilter, startDateFilter, endDateFilter],
                sort: getSortOrder(),
            })

            return records
        },
        
        async getTagsFresh(_, params) {
            let data = null
            await axios.get('/api/tags',{params}).then((response) => {
                data = response.data
            })

            return data
        },
        
        async getTag(_, id) {
            if (id === undefined || id === null) {
                throw new Error(`Invalid Tag ID specified: ${id}`)
            }

            const indexExists = await this.dispatch('indexExists', 'tag')

            if (indexExists) {
                return await this.dispatch('getRecord', {
                    index: 'tag',
                    id,
                })
            } else {
                return await this.dispatch('getTagFresh', id)
            }
        },

        async getTagFresh(_, id) {
            const indexExists = await this.dispatch('indexExists', 'tag')

            const { data } = await axios.get(`/api/tags/${id}`)
            if (!indexExists) {
                await this.dispatch('initTagIndex')
            }

            if (data) {
                await this.dispatch('addRecord', {
                    index: 'tag',
                    record: data,
                })
            }

            return data
        },

        async createTag(_, params) {
            await axios.post('/api/tags', params)
        },

        async editTag(_, params) {
            await axios.put(`/api/tags/${params.slug}`, params)
        },

        async deleteTag(_, params) {
            await axios.delete(`/api/tags/${params.slug}`)
        },

        async addMemberToTag(_,params){
            await axios.put(`/api/tags/${params.slug}/addmember`, params)
        },

        async removeMemberFromTag(_,params){
            await axios.put(`/api/tags/${params.slug}/removemember`, params)
        },
    },
}

export default tagModule
